var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWooshiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.611,
    height: 13.847,
    viewBox: "0 0 44.611 13.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #000000;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M434.427,288.621a1.067,1.067,0,0,0-1.067,1.067v4.84h-2.444v-4.84a1.067,1.067,0,0,0-2.133,0v11.7a1.067,1.067,0,1,0,2.133,0v-4.941h2.444v4.941a1.067,1.067,0,1,0,2.133,0v-11.7A1.067,1.067,0,0,0,434.427,288.621Z",
    transform: "translate(-394.211 -288.611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.772,288.61c-2.089,0-3.23,1.237-3.23,3.4v7.04c0,2.166,1.141,3.4,3.23,3.4s3.23-1.238,3.23-3.4v-7.04C410,289.847,408.86,288.61,406.772,288.61Zm1.1,10.579c0,.967-.425,1.334-1.1,1.334s-1.1-.368-1.1-1.334v-7.31c0-.968.425-1.335,1.1-1.335s1.1.368,1.1,1.335Z",
    transform: "translate(-391.71 -288.61)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M415.272,288.61c-2.088,0-3.23,1.237-3.23,3.4v7.04c0,2.166,1.141,3.4,3.23,3.4s3.23-1.238,3.23-3.4v-7.04C418.5,289.847,417.36,288.61,415.272,288.61Zm1.1,10.579c0,.967-.425,1.334-1.1,1.334s-1.1-.368-1.1-1.334v-7.31c0-.968.426-1.335,1.1-1.335s1.1.368,1.1,1.335Z",
    transform: "translate(-392.552 -288.61)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.625,288.621a1.067,1.067,0,0,0-1.067,1.067v11.7a1.067,1.067,0,1,0,2.133,0v-11.7A1.067,1.067,0,0,0,438.625,288.621Z",
    transform: "translate(-395.081 -288.611)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M424.486,294.817c-1.393-1.218-1.818-1.953-1.818-2.939,0-.968.387-1.335,1.064-1.335.594,0,.964.283,1.046,1.005a1,1,0,0,0,2-.081,2.839,2.839,0,0,0-3.105-2.858c-2.07,0-3.133,1.237-3.133,3.4,0,1.547.561,2.669,2.34,4.235,1.393,1.218,1.818,1.953,1.818,2.94,0,.967-.425,1.315-1.1,1.315s-1.091-.341-1.1-1.279a1,1,0,0,0-.976-1h-.045a1,1,0,0,0-.989.909c.027,2.117,1.106,3.326,3.169,3.326,2.089,0,3.172-1.238,3.172-3.4C426.827,297.507,426.265,296.384,424.486,294.817Z",
    transform: "translate(-393.389 -288.61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M400,288.61a1.038,1.038,0,0,0-1.039,1.038c0,.024.005.048.007.072v9.452c0,.967-.425,1.315-1.1,1.315s-1.1-.349-1.1-1.315v-9.523h0a1.038,1.038,0,0,0-2.077,0c0,.012,0,.022,0,.033v9.49c0,.967-.424,1.315-1.1,1.315s-1.1-.349-1.1-1.315v-9.524a1.039,1.039,0,0,0-2.078,0c0,.023.005.044.006.067v9.322c0,2.166,1.084,3.4,3.172,3.4a3.744,3.744,0,0,1,4.283-.02c2.089,0,3.172-1.238,3.172-3.4v-9.367h0A1.038,1.038,0,0,0,400,288.61Z",
    transform: "translate(-390.409 -288.61)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWooshiLogo);
export default __webpack_public_path__ + "static/media/wooshi-logo.ce00c60d332d487b622c300e0e6822d2.svg";
export { ForwardRef as ReactComponent };